/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import"../../chunks/OperatorIntersects.js";import"./support/apiConverter.js";export{a as accelerateGeometry,e as execute,s as supportsCurves}from"../../chunks/intersectsOperator.js";
